// Small pieces shared by the home page and the server leaderboards.
import { useState } from "react";
import { Icon } from "../icons";
import { formatMoney, formatNumber, formatPlaytime } from "../ui";

export type RankingKind = "islands" | "balance" | "playtime" | "mob-kills";

export function formatRankingValue(kind: RankingKind, item: any, data: any) {
  switch (kind) {
    case "playtime": return formatPlaytime(item.playtimeSeconds);
    case "balance": return formatMoney(item.balance);
    case "islands": return formatNumber(item[data?.rankingBy] ?? item.level);
    case "mob-kills": return formatNumber(item.mobKills);
  }
}
export function sourceUnavailable(data: any) { return Object.values(data?.sources || {}).some((source: any) => source?.available === false); }

export function PlayerHead({ name, size }: { name: unknown; size: number }) {
  const [failed, setFailed] = useState(false);
  const playerName = String(name || "").trim();
  return <span className="player-head" style={size === 36 ? undefined : { width: size, height: size }}>{playerName && !failed ? <img src={`https://mc-heads.net/avatar/${encodeURIComponent(playerName)}/${size * 2}`} alt="" width={size} height={size} onError={() => setFailed(true)}/> : (playerName || "?").slice(0, 2).toUpperCase()}</span>;
}

export function RankBadge({ rank }: { rank: number }) {
  return <span className={`rank-badge rank-${rank <= 3 ? rank : "other"}`}>{rank <= 3 && <Icon name="trophy" size={14}/>}<span className="sr-only">Rank </span>#{rank}</span>;
}
